import { Button, ButtonProps } from '@material-ui/core';

import { TimeInterval } from '@/components/modules/Metrics/shared/entities/TimeInterval';
import { Text } from '@/components/shared/components/Text';

interface StyledButtonProps extends ButtonProps {
  timeInterval?: TimeInterval;
  label?: string;
}

export const StyledButton = ({ timeInterval, label, ...props }: StyledButtonProps) => {
  return (
    <Button
      variant={'contained'}
      color={props.value === timeInterval?.type ? 'secondary' : 'default'}
      {...props}
      disableElevation
      size={'small'}
      style={{
        ...props?.style,
        display: 'flex',
        width: 'max-content',
        justifyContent: 'space-between',
        minWidth: '180px',
      }}
    >
      {label ?? <Text tId={props.value as unknown as string} />}
    </Button>
  );
};
